<template>
    <div class="funded">
        <div class="box">
            <div class="head">
                <p>{{detail.name}}（{{detail.amac_no}}）</p>
                <span class="key">单位净值：</span>
                <span class="value">{{detail.nav}}</span>
                <span class="date">({{detail.nav_date}})</span>
                <hr>
            </div>
            <div class="info">
                <div class="vertical">
                    <span class="key">基金状态：</span>
                    <span class="value">{{detail.status}}</span>
                    <br>
                    <span class="key">备案编号：</span>
                    <span class="value">{{detail.amac_no}}</span>
                </div>
                <div class="vertical">
                    <span class="key">成立时间：</span>
                    <span class="value">{{detail.register_date}}</span>
                    <br>
                    <span class="key">起投金额：</span>
                    <span class="value">{{detail.invest_first}}</span>
                </div>
                <div class="vertical">
                    <span class="key">基金经理：</span>
                    <span class="value">{{detail.managers}}</span>
                    <br>
                    <span class="key">投资顾问：</span>
                    <span class="value">{{detail.adviser}}</span>
                </div>
                <div class="vertical">
                    <span class="key">累计净值：</span>
                    <span class="value">{{detail.cuv}}</span>
                    <br>
                    <span class="key">累计收益：</span>
                    <span class="value">{{sum}}</span>
                </div>
            </div>
            <div class="process">
                <span class="h">购买流程</span>
                <span class="s">实名预约额度</span>
                <span>------</span>
                <span class="s">获取专属合同</span>
                <span>------</span>
                <span class="s">进行打款</span>
                <span>------</span>
                <span class="s">回寄资料</span>
                <span>------</span>
                <span class="s">产品成立、回寄合同资料</span>
            </div>
            <div class="record">
                <div class="head">
                    <span>基金业绩</span>
                </div>
                <div class="charts">
                    <p>{{detail.name}}({{detail.amac_no}})<br> - 收益走势图</p>
                    <div class="e-record" id="Records"></div>
                </div>
                <div class="table">
                    <div class="tab">
                        <span class="active">历史净值表</span>
                        <span>历史回撤表</span>
                    </div>
                    <div class="header">
                        <span>净值日期</span>
                        <span>单位净值</span>
                        <span>累计净值</span>
                        <span>涨跌幅</span>
                    </div>
                    <div class="body">
                        <div class="tr" v-for="(item, index) in fund_record1" :key="index">
                            <span>{{item.nav_date}}</span>
                            <span>{{item.unv}}</span>
                            <span>{{item.cnv}}</span>
                            <span>--</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {post} from '@/http.js'
export default {
    data() {
        return {
            id: 4,
            detail: [],
            fund_record: [],
            fund_record1: []
        }
    },
    created() {
        this.id = this.$route.query.id;
        post('query/fund_detail', {
            fund_id: this.id
        }).then((res) => {
            this.detail = res[0];
            post('query/fund_nav', {
                fund_id: this.id,
                amac_no: this.detail.amac_no,
                // asc: false
            }).then((res) => {
                this.setRecords(res[0].records)
                this.fund_record = res[0].records
                this.fund_record1 = this.fund_record.sort(this.compare('nav_date', false))
            })
        }, () => {
            this.$router.push('/featured')
        });
        
        if(!this.score) {
            this.$store.commit('changePop', 'auth')
        }
        
    },
    computed: {
        score() {
            return this.$store.state.score
        },
        sum() {
            if(!this.score) {
                return '---'
            }
            return ((this.detail.cuv - 1) * 100).toFixed(2) + '%';
        }
    },
    methods: {
        setRecords(data) {
            let date = [];
            let jingzhi = [];
            for(let i = 0, l = data.length; i < l; i++) {
                date[i] = data[i].nav_date;
                jingzhi[i] = data[i].unv;
            }
            /* global echarts */
            var record = echarts.init(document.getElementById('Records'));
            record.setOption({
                xAxis: {
                    type: 'category',
                    data: date
                },
                yAxis: {
                    type: 'value',
                    scale: true
                },
                series: [
                    {
                        data: jingzhi,
                        type: 'line',
                        name: '净值'
                    }
                ],
                legend: {
                    data: ['净值'],
                    bottom: 10
                },
                grid: {
                    top: 10
                },
                tooltip: {
                    trigger: 'axis'
                },
            })
        },
        /** 两个参数： 参数1 是排序用的字段， 参数2 是：是否升序排序 true 为升序，false为降序*/
        compare(attr,rev) {
            // console.log(attr, rev)
            if (rev ==  undefined) {
                rev = 1;
            } else {
                rev = (rev) ? 1 : -1;
            }
            return (a,b) => {
                a = a[attr];
                b = b[attr];
                if (a < b){
                    return rev * -1;
                }
                if (a > b){
                    return rev * 1;
                }
                return 0;
            }
        }
    },
}
</script>